import React from 'react';

// The real App Store listing (Swiss storefront) - same URL the site has always used.
export const APP_STORE_URL = 'https://apps.apple.com/ch/app/snapcipe-ai/id6745421452?l=en-GB';

const AppleGlyph = () => (
  <svg viewBox="0 0 384 512" width="19" height="19" fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-36.8-2.8-77 21.3-91.7 21.3-15.5 0-51.1-20.3-79.1-20.3C61.2 141.2 4 184.8 4 273.5c0 26.2 4.8 53.3 14.4 81.2 12.8 36.7 62.2 126.2 113.7 124.6 26.9-.6 45.9-19.1 81-19.1 34 0 51.6 19.1 81.6 19.1 52-.8 96.7-82.1 108.9-118.9-65.3-30.8-84.9-60.8-84.9-91.7zM255.2 105.8c25.4-30.1 23.1-57.5 22.4-67.3-22.5 1.3-48.5 15.3-63.3 32.6-16.3 18.5-25.9 41.4-23.8 67 24.3 1.9 46.5-10.6 64.7-32.3z" />
  </svg>
);

/**
 * Primary App Store CTA. `withGlyph` prefixes the Apple mark.
 */
const AppStoreLink = ({ children = 'Download on iOS', withGlyph = true, className = 'cta', style }) => {
  const handleClick = () => {
    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'Download',
        event_label: 'App Store',
      });
    }
  };

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      onClick={handleClick}
    >
      {withGlyph && <AppleGlyph />}
      {children}
    </a>
  );
};

export default AppStoreLink;
